import Vue from 'vue'
import menuService from '@/services/menuService'

// Estado reativo para os menus
const state = Vue.observable({
  menus: [],
  loading: false,
  error: null
})

// Mutações
const mutations = {
  SET_LOADING (loading) {
    state.loading = loading
  },
  SET_MENUS (menus) {
    state.menus = Array.isArray(menus) ? menus : []
  },
  SET_ERROR (error) {
    state.error = error
  },
  CLEAR_ERROR () {
    state.error = null
  }
}

// Ações
const actions = {
  async fetchMenus () {
    try {
      mutations.SET_LOADING(true)
      mutations.CLEAR_ERROR()

      const menus = await menuService.getMenusByTenant()
      mutations.SET_MENUS(menus)

      return menus
    } catch (error) {
      mutations.SET_ERROR(error)
      console.error('Erro ao carregar menus:', error)
      throw error
    } finally {
      mutations.SET_LOADING(false)
    }
  }
}

// Getters
const getters = {
  menus: () => state.menus,
  loading: () => state.loading,
  error: () => state.error,
  hasMenus: () => state.menus && state.menus.length > 0
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/menuStore.js